
export default {
    list: [],
    service: null,
    currentService: null,
    loading: false,
    api: null,
    types: null
}